/**
 * ChapterSummary entity schema
 */

import { z } from 'zod';
import { ChapterStatusSchema, ChapterBoundaryTriggerSchema } from '../enums';

export const KeyQuoteSchema = z.object({
  speaker: z.string(),
  quote: z.string(),
});

export type KeyQuote = z.infer<typeof KeyQuoteSchema>;

export const ChapterSummarySchema = z.object({
  id: z.string(),
  world_id: z.string(),
  arc_id: z.string(),
  chapter_number: z.number().int().positive(),
  title: z.string().nullable(),
  summary: z.string(),
  major_beats: z.array(z.string()).nullable(),
  status: ChapterStatusSchema,
  started_at: z.string(),
  completed_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  first_message_id: z.string().nullable(),
  last_message_id: z.string().nullable(),
  message_count: z.number().int().nonnegative(),
  primary_location: z.string().nullable(),
  key_quotes: z.array(KeyQuoteSchema).nullable(),
  boundary_trigger: ChapterBoundaryTriggerSchema.nullable(),
  emotional_arc: z.string().nullable(),
});

export type ChapterSummary = z.infer<typeof ChapterSummarySchema>;
